import { Inject, Injectable } from '@angular/core';

import { SdkMessageHandler, SdkMessageHandlerCallback } from './../../../../api';
import { createConsumerOnSubject, createSetModeHandler } from './../../../../utils';
import { USE_PUBLIC_URL } from './../../../utils/urls';
import { WchLoggerService } from './../../logger/wch.logger.service';

/* Copyright IBM Corp. 2018 */
const LOGGER = 'SdkSetModeHandler';

/**
 * Executes a navigation event
 */
@Injectable()
export class SdkSetModeHandler implements SdkMessageHandler {

    handle: SdkMessageHandlerCallback;

    constructor(@Inject(WchLoggerService) loggerService: WchLoggerService) {
        // create the handler
        this.handle = createSetModeHandler(createConsumerOnSubject(USE_PUBLIC_URL), loggerService.get(LOGGER));
    }

}
